/* global APPSTLE_PROPS, routes, ReportSentry, CartPerformance, PUB_SUB_EVENTS, publish, nanoid */

class ProductInfoSubscriptionWhy extends HTMLElement {
  constructor() {
    super()
    this.button = null
    this.onClickBound = this.handleSubscribeClick.bind(this)
  }

  connectedCallback() {
    this.button = this.querySelector('button.sub-why-cta')
    this.button.classList.remove('loading')
    this.button.addEventListener('click', this.onClickBound)
  }

  async handleSubscribeClick(event) {
    const { formId } = this.button.dataset
    const form = document.getElementById(formId)
    if (!form) return

    const formData = new FormData(form)
    const selectedFilterSellingPlans = this.getFilterSellingPlans(formId)
    const cartElement = document.querySelector('cart-drawer')
    const variantId = formData.get('id')

    this.button.setAttribute('aria-disabled', 'true')
    this.button.classList.add('loading')

    try {
      if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cartElement.getSectionsToRender()?.map(section => section.id)
        )
      }

      const response = await this.addSubscriptionBundleToCart(formData, selectedFilterSellingPlans)

      if (response.status) {
        this.reportCartError(response, variantId)
        return
      }

      if (!cartElement) {
        window.location = (window.routes && window.routes.cart_url) || '/cart'
        return
      }

      this.publishCartUpdate(response, variantId)
      this.renderCart(cartElement, response)
      if (typeof cartElement.disableLoading === 'function') cartElement.disableLoading(0)
      this.closeSidebar()
    } catch (error) {
      ReportSentry.cartAddError({
        variantId,
        quantity: 1,
        error,
        isNetworkError: true
      })
      console.error(error)
    } finally {
      this.button.classList.remove('loading')
      this.button.removeAttribute('aria-disabled')

      if (cartElement && cartElement.classList.contains('is-empty')) cartElement.classList.remove('is-empty')
      if (typeof CartPerformance !== 'undefined') CartPerformance.measureFromEvent('add:user-action', event)
      this.reportSubscriptionWdEvent(selectedFilterSellingPlans)
    }
  }

  getFilterSellingPlans(formId) {
    // 这些复选框不在 product form 内部，需要通过 form 属性读取。
    return Array.from(document.querySelectorAll(`input[name="filter_selling_plan[]"][form="${formId}"]:not(:disabled)`))
      .map(input => input.value)
      .filter(Boolean)
  }

  async addSubscriptionBundleToCart(formData, selectedFilterSellingPlans) {
    const variables = { sections: formData.get('sections'), items: [] }
    const id = formData.get('id')
    const relatedId = nanoid(6)

    // 先添加订阅滤芯，确保购物车里主机商品最后渲染。
    for (let j = selectedFilterSellingPlans.length - 1; j >= 0; j--) {
      const filterItem = selectedFilterSellingPlans[j]
      const [sellingPlan, filterId, perDelivery] = filterItem.split('|').map(part => part.trim())
      if (!sellingPlan || !filterId) continue

      variables.items.push({
        quantity: 1,
        id: filterId,
        selling_plan: sellingPlan,
        parent_id: id,
        properties: {
          [APPSTLE_PROPS.SELECTED_PLAN]: sellingPlan,
          [APPSTLE_PROPS.FULFILLMENT_COUNT]: '1',
          __related: relatedId,
          __per_delivery: perDelivery
        }
      })
    }

    variables.items.push({ quantity: 1, id, properties: { __related: relatedId } })

    const response = await fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      body: JSON.stringify(variables),
      headers: { 'Content-Type': 'application/json' }
    })

    return response.json()
  }

  reportCartError(response, variantId) {
    publish(PUB_SUB_EVENTS.cartError, {
      source: 'product-info-subscription-why',
      productVariantId: variantId,
      errors: response.errors || response.description,
      message: response.message
    })
    ReportSentry.cartAddError({ variantId, quantity: 1, response })
  }

  publishCartUpdate(response, variantId) {
    const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers')

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'product-info-subscription-why',
      productVariantId: variantId,
      cartData: response
    }).then(() => {
      CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker)
    })
  }

  renderCart(cartElement, response) {
    if (typeof cartElement.renderContents === 'function') {
      CartPerformance.measure('add:paint-updated-sections', () => {
        cartElement.renderContents(response)
      })
      return
    }

    console.warn('Cart component does not have renderContents method, falling back to onCartUpdate')
    if (typeof cartElement.onCartUpdate === 'function') cartElement.onCartUpdate()
  }

  closeSidebar() {
    const { containerId } = this.dataset
    const sidebar = document.getElementById(containerId)
    if (typeof sidebar?.hide === 'function') sidebar.hide()
  }

  reportSubscriptionWdEvent(selectedFilterSellingPlans) {
    try {
      if (!selectedFilterSellingPlans.length || typeof window.WDSendEvent !== 'function') return

      // 与 PDP 主商品表单的订阅埋点 payload 保持一致。
      const subscribeRadio = document.querySelector('product-filter-subscription-radio')
      const wdEvent = subscribeRadio?.dataset?.wdEvent ?? '{}'
      const { event_action: eventAction, event_label: eventLabel = {} } = JSON.parse(wdEvent)
      const skus = selectedFilterSellingPlans
        .map(plan => plan.split('|')[0])
        .filter(id => eventLabel[id])
        .map(id => eventLabel[id])

      window.WDSendEvent('wd_add_to_cart_subscription', {
        event_source: 'pdp-info',
        event_action: eventAction,
        event_label: skus.join(',')
      })
    } catch (error) {
      console.error(error)
    }
  }
}

if (!customElements.get('product-info-subscription-why')) {
  customElements.define('product-info-subscription-why', ProductInfoSubscriptionWhy)
}
